import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentPath: "/",
    menuCss: "menu call-english",
    telNo: "",
    email: "",
  },
  mutations: {
    setCurrentPath(state, payload) {
      state.currentPath = payload;
      if (state.currentPath === "/edu-tech") {
        state.menuCss = "menu edu-tech";
      } else {
        state.menuCss = "menu call-english";
      }

      //전화번호, 이메일 설정
      if (state.currentPath === "/edu-tech") {
        state.telNo = "02-518-2603";
        state.email = "imooc@carrotglobal.com";
      } else if (state.currentPath === "/imooc") {
        state.telNo = "02-518-2603";
        state.email = "imooc@carrotglobal.com";
      } else if (state.currentPath === "/aitutor") {
        state.telNo = "02-518-2603";
        state.email = "aitutor@carrotglobal.com";
      } else if (state.currentPath === "/custom-cont") {
        state.telNo = "02-518-2603";
        state.email = "research@carrotglobal.com";
      } else {
        state.telNo = "02-518-0036";
        state.email = "helpcarrot@carrotglobal.com";
      }
    },
    setMenuCss(state, payload) {
      state.menuCss = payload;
    },
  },
  getters: {
    getMeunCss(state) {
      return state.menuCss;
    },
    getCurrentPath(state) {
      return state.currentPath;
    },
    getTelNo(state) {
      return state.telNo;
    },
    getEmail(state) {
      return state.email;
    },
  },
  actions: {},
  modules: {},
});
